import { MoreVertical, ChevronLast, ChevronFirst } from "lucide-react";
import { createContext, useEffect, useState } from "react";
import { SidebarItem } from "./SidebarItem";
import AitiuLogo from "../assets/HarmaLogo.png";
import AitiuLogoDark from "../assets/7.png"
import { useDispatch, useSelector } from "react-redux";
import { toggleSidebar, initializeSidebar } from "../slices/sidebarSlice";
import { useNavigate } from "react-router-dom"; // Usamos useNavigate para la navegación

const SidebarContext = createContext();

export default function SidebarClient({ userInfo, routes }) {
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const { isDarkMode } = useSelector((state) => state.darkMode);
  
  

  const { expanded } = useSelector((state) => state.sidebar); 

  useEffect(() => {
    // Inicializamos el estado del sidebar desde la cookie cuando el componente se monta
    dispatch(initializeSidebar());
  }, [dispatch]);

  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false); // Estado para controlar la visibilidad del menú de perfil

  const userName = userInfo?.name || "Default Name";
  const userLastName = userInfo?.lastName || "Default Last Name";
  const userEmail = userInfo?.email || "default@example.com";
  const userProfileImage = userInfo?.profileImage || (userInfo ? `https://ui-avatars.com/api/?name=${userName}${userLastName}&background=random` : "user");


  const handleProfileClick = () => {
    navigate("/admin/settings"); // Redirige a la página de perfil de usuario
  };

  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen); // Cambia el estado para mostrar u ocultar el menú de perfil
  };

  return (
    <aside
      className={`fixed sm:h-full h-16 sm:block hidden top-0 sm:left-0 right-0 bottom-0 bg-background border-r sm:shadow-sm shadow-md  z-50 transition-all ${
        expanded ? " sm:w-64 h-60 " : " sm:w-20 "
      }`}
    >
      <nav className="h-full flex flex-col">
        {/* Sección del Logo y el botón para expandir o colapsar el Sidebar */}
        <div className="sm:p-4 p-2 pb-2 flex justify-between items-center">
          <img
            src={isDarkMode ? AitiuLogoDark : AitiuLogo }
            className={`overflow-hidden transition-all ${
              expanded ? "sm:w-52 w-28 " : "w-0"
            }`}
            alt="Logo"
          />

          <button
            onClick={() => dispatch(toggleSidebar())} // Cambiamos el estado del sidebar usando Redux
            className="p-1.5 rounded-lg bg-gray-50 hover:bg-gray-100"
          >
            {expanded ? <ChevronFirst /> : <ChevronLast />}
          </button>
        </div>

        {/* Proveemos el contexto para los items del Sidebar */}
        <SidebarContext.Provider value={{ expanded }}>
          <ul className="flex-1 sm:px-3 px-0 overflow-y-auto sm:text-xl text-sm  ">
            {routes[1].pages.filter((page) => !page.hidden ).map((route) => (
              <SidebarItem
                key={route.name}
                icon={route.icon}
                text={route.name}
                expanded={expanded}
                path={"/client" + route.path}
              />
            ))}
          </ul>
        </SidebarContext.Provider>

        {/* Información del usuario */}
        <div className="border-t flex p-3">
          {/* Foto de perfil siempre visible */}
          <div
            className={`relative group   `}
          >
            <img
              src={userProfileImage}
              alt="User Avatar"
              className="w-12 object-cover h-10 rounded-md cursor-pointer"
              onClick={handleProfileClick} // Redirige al hacer clic en la foto
            />
            {/* Si el menú no está expandido, muestra el tooltip con "Perfil" */}
            {!expanded && (
              <div
                className={`
                  absolute bottom-12 left-14 transform -translate-x-1/2
                  bg-gray-700 text-white text-xs ml-1 p-2 rounded shadow-lg z-50
                  opacity-0 invisible transition-opacity duration-200
                  group-hover:opacity-100 group-hover:visible
                `}
                style={{ whiteSpace: "nowrap" }}
              >
                Perfil
              </div>
            )}
          </div>

          {/* Información adicional del usuario */}
          <div
            className={`flex justify-between items-center overflow-hidden transition-all ${
              expanded ? "w-52 ml-3" : "w-0"
            }`}
          >
            <div className="leading-4">
              <h4 className="font-semibold text-text ">
                {userName} {userLastName}
              </h4>
              <span className="text-xs text-gray-600">{userEmail}</span>
            </div>
          </div>
          {/* Si el menú está expandido, el icono MoreVertical se convierte en un botón de Perfil */}
          {expanded && (
            <div
              className="relative flex items-center gap-x-2 cursor-pointer"
              onClick={toggleProfileMenu}
            >
              <MoreVertical size={20} />
              {/* Menú de perfil desplegable, se posiciona al lado del icono */}
              {isProfileMenuOpen && (
                <div className="absolute top-0 left-full ml-2 mt-2 bg-white shadow-md p-2 rounded-lg z-50">
                  <button
                    onClick={handleProfileClick}
                    className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded"
                  >
                    Perfil
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </nav>
    </aside>
  );
}
